// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__2BC13","paramInput":"JobSimulator_paramInput__21-Dc","input":"JobSimulator_input__1Jzwv"};